import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/arch/Layout';
import Login from '@/app/Login/Login';
import LoginService from '@/services/LoginService';
import Dashboard from '@/app/Dashboard/Dashboard';

import routes from './routes';

Vue.use(Router);

const notFound = {
  path: '*',
  name: 'NotFound',
  component: () => import('@/app/NotFound/NotFound'),
  meta: {
    domain: 'NotFound',
    sidebar: false,
    title: 'Não encontrado',
  },
};

const router = new Router({
  routes: [
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
    },
    {
      path: '/',
      component: Layout,
      children: routes,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '*',
      component: Layout,
      children: [notFound],
    },
  ],
});

router.beforeEach((to, from, next) => {
  const token = LoginService.obterToken();
  const login = 'login';

  if (!token && to.name !== login) {
    return next('/login');
  }

  return next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js